<template>
    <div>
        <!-- <v-btn
            v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
            :loading="loading" 
            tile small dark class="" color="orange" @click="getVerificar()">
            <v-icon>mdi-download</v-icon> Verificar
        </v-btn> -->

        <download-excel
            class            = "v-btn v-btn--is-elevated v-btn--has-bg v-btn--tile theme--dark v-size--small orange"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            worksheet        = "recibos" 
            name             = "verificar.xls" >
            Verificar Netsuite
        </download-excel>
        
        <v-progress-linear indeterminate height="2" v-if="loading"/>
    </div>
</template>

<script>
import xaxios from '@/xaxios';

export default {
    data(){
        return{
            formData: {},
            loading: false,
            json_fields: {
                'Depositante': 'nombre_depositante',
                'Numero recibo': 'numero_recibo',
                'Fecha del pago': 'fecha_pago',
                'Fecha Registro': 'fecha_registro',
                'Observacion': 'observacion',
            },
        }
    },
    methods: {
        setData(data={}){
            this.formData = {...data}
        },
        /*async getVerificar(){
            // window.console.log("verificarrr", this.formData);
            this.loading = true;
            const url = `${process.env.VUE_APP_API_REST}/api/pagos/recibos/buscar`;
            let res = await xaxios.post(url, this.formData).then(({data})=>data).catch(e=>e);
            window.console.log('>>>>', res);
            this.loading = false;
        },*/
        async fetchData(){
            // if(this.loading) return;
            // const url = `${process.env.VUE_APP_API_REST}/api/pagos/recibos/buscar`;
            // const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/pagos_inscripcion_queue`;
            const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/verificar_recibos_netsuite`;
            let res = await xaxios.post(url, this.formData).then(({data})=>data).catch(e=>e);
            return res;
        },
        startDownload(){
            this.loading = true;
        },
        finishDownload(){
            this.loading = false;
        }
    }
}

</script>